import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useServices, useStore } from "../../hooks";
import { store } from "../../store";
import { showErrorNotification } from "../../utils";
import { FormLayout } from "@qpd-reestr/layout";

/**
 * Обработчик перехода в ИС
 */
const ExternalSystemAuthorizationHandler: React.FC = () =>
{ 
    const navigate = useNavigate();
        const services = useServices();
        const { userStore, externalSystemAuthStore } = useStore();
        const { redirectUri, redirectParams } = externalSystemAuthStore;
    
        useEffect(() => {
            if(!redirectUri) navigate("/");
        
            // Получаем идентификатор клиента
            let clientId = redirectParams?.get('client_id') ?? "";

            // флаг, что приходим авторизовваться под тем же пользвателем
            const userId = redirectParams?.get('userId') ?? "";
            let isSameUser = userId ? userId === store.userStore.currentUserId : true;

            // если не указан идентификатор клиента
            // Если не авторизован
            // если другой польователь
            if (!clientId || !userStore.isAuthorized || !isSameUser) {
                return navigate('/');
            }

            // эти параметры были сфомированы клиентом(внешней системой)
            const state = redirectParams?.get("state") ?? "";
            const codeChallenge = redirectParams?.get("code_challenge") ?? "";
            const nonce = redirectParams?.get("nonce") ?? "";

            (async () => {
                try {
                    
                    const externalSystemDto = await services.externalSystemService.getExternalSystem({ clientId });
                    
                    const authorizationCodeDto = await services.externalSystemService.getAuthorizationCode({
                        clientId,
                        state: externalSystemDto.state,
                        codeChallenge,
                        nonce
                    });
                    
                    const redirect = redirectUri ?? externalSystemDto.externalSystem.systemInfo.site;

                    var url = new URL(redirect);
                    url.searchParams.append("code", authorizationCodeDto.authorizationCode);
                    url.searchParams.append("state", state);
                    
                    (window as Window).location = url.toString();
                } catch (error: any) {
                    showErrorNotification(error);
                    navigate('/');
                } finally {
                    externalSystemAuthStore.clear();
                }
            })();
            

       }, [
           userStore.isAuthorized,
           redirectUri
       ]);

    return <FormLayout registrarKey={process.env.REACT_APP_REGISTRAR_KEY ?? ""}></FormLayout>
}

export default ExternalSystemAuthorizationHandler;